/** Board payload from Monday `items { board, subitems { board } }` column-picker queries. */
export type BoardColumnPickerBoard = {
  id: string;
  columns?: Array<{
    id: string;
    settings_str?: string;
    title: string;
    type: string;
    archived?: boolean;
  }>;
};

export type ItemForColumnPickers = {
  board?: BoardColumnPickerBoard | null;
  subitems?: Array<{ board?: BoardColumnPickerBoard | null }> | null;
};

/**
 * Classic boards use a dedicated subitem board; MLS child items share the parent board.
 * Prefer the subitem board when it differs from the parent; otherwise use the parent board.
 */
export function resolveBoardForColumnPickers(
  item: ItemForColumnPickers | null | undefined,
): BoardColumnPickerBoard | null | undefined {
  if (!item) {
    return null;
  }

  const parentBoard = item.board;
  const subitemBoard = item.subitems?.[0]?.board;

  if (
    subitemBoard?.id &&
    parentBoard?.id &&
    subitemBoard.id !== parentBoard.id
  ) {
    return subitemBoard;
  }

  return parentBoard ?? subitemBoard ?? null;
}
